toggleMenu();
function toggleMenu() {
  const menuButton = document.querySelector('.original-header__toggle-button');
  const mainMenu = document.querySelector('.original-header__menu');

  [menuButton, mainMenu].forEach(elm => {
    elm.addEventListener('click', function () {
      menuButton.classList.toggle('active');

      if (menuButton.classList.contains('active')) {
        mainMenu.classList.add('active');
      } else {
        mainMenu.classList.remove('active');
      }
    });
  });
}